export const COLOR_SCHEME = {
  system: 'system',
  light: 'light',
  dark: 'dark',
};

export const COLOR_SCHEME_STORAGE_KEY = 'servgrow-portal-color-scheme';

const DARK_QUERY = '(prefers-color-scheme: dark)';

const isColorScheme = (value) => Object.values(COLOR_SCHEME).includes(value);

export const readStoredScheme = () => {
  try {
    const stored = window.localStorage.getItem(COLOR_SCHEME_STORAGE_KEY);

    return isColorScheme(stored) ? stored : COLOR_SCHEME.system;
  } catch {
    return COLOR_SCHEME.system;
  }
};

export const storeScheme = (scheme) => {
  try {
    window.localStorage.setItem(COLOR_SCHEME_STORAGE_KEY, scheme);
  } catch {
    // A portal opened with site data blocked still themes for the session.
  }
};

export const resolveScheme = (scheme, prefersDark) => {
  if (scheme === COLOR_SCHEME.dark || scheme === COLOR_SCHEME.light) {
    return scheme;
  }

  return prefersDark ? COLOR_SCHEME.dark : COLOR_SCHEME.light;
};

export const prefersDark = () => {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return false;
  }

  return window.matchMedia(DARK_QUERY).matches;
};

export const subscribeToSystemScheme = (onChange) => {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return () => {};
  }

  const query = window.matchMedia(DARK_QUERY);
  const handler = (event) => onChange(event.matches);

  if (query.addEventListener) {
    query.addEventListener('change', handler);

    return () => query.removeEventListener('change', handler);
  }

  query.addListener(handler);

  return () => query.removeListener(handler);
};
